export default "__VITE_ASSET__DwzUy3AL__"